export const GET_LIST_USER_PENDING = "GET_LIST_USER_PENDING";
export const GET_LIST_USER_SUCCESS = "GET_LIST_USER_SUCCESS";
export const GET_LIST_USER_FAILED = "GET_LIST_USER_FAILED";

export const GET_DETAIL_USER_PENDING = "GET_DETAIL_USER_PENDING";
export const GET_DETAIL_USER_SUCCESS = "GET_DETAIL_USER_SUCCESS";
export const GET_DETAIL_USER_FAILED = "GET_DETAIL_USER_FAILED";

export const GET_LIST_CATEGORY_PENDING = "GET_LIST_CATEGORY_PENDING";
export const GET_LIST_CATEGORY_SUCCESS = "GET_LIST_CATEGORY_SUCCESS";
export const GET_LIST_CATEGORY_FAILED = "GET_LIST_CATEGORY_FAILED";

export const GET_LIST_NEW_PRODUCT_PENDING = "GET_LIST_NEW_PRODUCT_PENDING";
export const GET_LIST_NEW_PRODUCT_SUCCESS = "GET_LIST_NEW_PRODUCT_SUCCESS";
export const GET_LIST_NEW_PRODUCT_FAILED = "GET_LIST_NEW_PRODUCT_FAILED";

export const GET_LIST_PRODUCT_PENDING = "GET_LIST_PRODUCT_PENDING";
export const GET_LIST_PRODUCT_SUCCESS = "GET_LIST_PRODUCT_SUCCESS";
export const GET_LIST_PRODUCT_FAILED = "GET_LIST_PRODUCT_FAILED";

export const GET_MY_CART_PENDING = "GET_MY_CART_PENDING";
export const GET_MY_CART_SUCCESS = "GET_MY_CART_SUCCESS";
export const GET_MY_CART_FAILED = "GET_MY_CART_FAILED";

export const GET_LIST_PRODUCT_BY_CATEGORY_PENDING = "GET_LIST_PRODUCT_BY_CATEGORY_PENDING";
export const GET_LIST_PRODUCT_BY_CATEGORY_SUCCESS = "GET_LIST_PRODUCT_BY_CATEGORY_SUCCESS";
export const GET_LIST_PRODUCT_BY_CATEGORY_FAILED = "GET_LIST_PRODUCT_BY_CATEGORY_FAILED";

export const GET_DETAIL_PRODUCT_PENDING = "GET_DETAIL_PRODUCT_PENDING";
export const GET_DETAIL_PRODUCT_SUCCESS = "GET_DETAIL_PRODUCT_SUCCESS";
export const GET_DETAIL_PRODUCT_FAILED = "GET_DETAIL_PRODUCT_FAILED";

export const GET_LIST_USER_CHAT_PENDING = "GET_LIST_USER_CHAT_PENDING";
export const GET_LIST_USER_CHAT_SUCCESS = "GET_LIST_USER_CHAT_SUCCESS";
export const GET_LIST_USER_CHAT_FAILED = "GET_LIST_USER_CHAT_FAILED";

export const GET_DETAIL_RECEIVER_PENDING = "GET_DETAIL_RECEIVER_PENDING";
export const GET_DETAIL_RECEIVER_SUCCESS = "GET_DETAIL_RECEIVER_SUCCESS";
export const GET_DETAIL_RECEIVER_FAILED = "GET_DETAIL_RECEIVER_FAILED";

export const GET_MY_ADDRESS_PENDING = "GET_MY_ADDRESS_PENDING";
export const GET_MY_ADDRESS_SUCCESS = "GET_MY_ADDRESS_SUCCESS";
export const GET_MY_ADDRESS_FAILED = "GET_MY_ADDRESS_FAILED";

export const GET_ALL_CATEGORIES_ADMIN_PENDING = "GET_ALL_CATEGORIES_ADMIN_PENDING";
export const GET_ALL_CATEGORIES_ADMIN_SUCCESS = "GET_ALL_CATEGORIES_ADMIN_SUCCESS";
export const GET_ALL_CATEGORIES_ADMIN_FAILED = "GET_ALL_CATEGORIES_ADMIN_FAILED";

export const GET_DETAIL_CATEGORIES_ADMIN_PENDING = "GET_DETAIL_CATEGORIES_ADMIN_PENDING";
export const GET_DETAIL_CATEGORIES_ADMIN_SUCCESS = "GET_DETAIL_CATEGORIES_ADMIN_SUCCESS";
export const GET_DETAIL_CATEGORIES_ADMIN_FAILED = "GET_DETAIL_CATEGORIES_ADMIN_FAILED";

export const GET_ALL_BRANDS_ADMIN_PENDING = "GET_ALL_BRANDS_ADMIN_PENDING";
export const GET_ALL_BRANDS_ADMIN_SUCCESS = "GET_ALL_BRANDS_ADMIN_SUCCESS";
export const GET_ALL_BRANDS_ADMIN_FAILED = "GET_ALL_BRANDS_ADMIN_FAILED";

export const GET_DETAIL_BRANDS_ADMIN_PENDING = "GET_DETAIL_BRANDS_ADMIN_PENDING";
export const GET_DETAIL_BRANDS_ADMIN_SUCCESS = "GET_DETAIL_BRANDS_ADMIN_SUCCESS";
export const GET_DETAIL_BRANDS_ADMIN_FAILED = "GET_DETAIL_BRANDS_ADMIN_FAILED";

export const GET_ALL_BUYERS_ADMIN_PENDING = "GET_ALL_BUYERS_ADMIN_PENDING";
export const GET_ALL_BUYERS_ADMIN_SUCCESS = "GET_ALL_BUYERS_ADMIN_SUCCESS";
export const GET_ALL_BUYERS_ADMIN_FAILED = "GET_ALL_BUYERS_ADMIN_FAILED";

export const GET_ALL_SELLERS_ADMIN_PENDING = "GET_ALL_SELLERS_ADMIN_PENDING";
export const GET_ALL_SELLERS_ADMIN_SUCCESS = "GET_ALL_SELLERS_ADMIN_SUCCESS";
export const GET_ALL_SELLERS_ADMIN_FAILED = "GET_ALL_SELLERS_ADMIN_FAILED";

export const GET_ALL_TRANSACTION_ADMIN_PENDING = "GET_ALL_TRANSACTION_ADMIN_PENDING";
export const GET_ALL_TRANSACTION_ADMIN_SUCCESS = "GET_ALL_TRANSACTION_ADMIN_SUCCESS";
export const GET_ALL_TRANSACTION_ADMIN_FAILED = "GET_ALL_TRANSACTION_ADMIN_FAILED";
